import { render } from "./ManageUsers.vue?vue&type=template&id=54fa72ea&scoped=true"
import script from "./ManageUsers.vue?vue&type=script&lang=js"
export * from "./ManageUsers.vue?vue&type=script&lang=js"

import "./ManageUsers.vue?vue&type=style&index=0&id=54fa72ea&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fa72ea"]])

export default __exports__